import React from 'react';

import { MenuItem, Stack, TextField } from '@mui/material';

import { DEFAULT_PRINT_SETTINGS, type PrintSettings } from './printSettings';

export default function PrintSettingsFields({
  value = DEFAULT_PRINT_SETTINGS,
  onChange,
  showImage = true,
  showPdf = true,
}: {
  value?: PrintSettings;
  onChange: (value: PrintSettings) => void;
  showImage?: boolean;
  showPdf?: boolean;
}) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
      {showPdf && (
        <TextField
          select
          label="PDF orientation"
          size="small"
          value={value.orientation}
          onChange={(event) =>
            onChange({ ...value, paper: 'a4', orientation: event.target.value as PrintSettings['orientation'] })
          }
          title="A4, one page per sheet. Automatic chooses orientation per sheet."
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="auto">Automatic</MenuItem>
          <MenuItem value="portrait">Portrait</MenuItem>
          <MenuItem value="landscape">Landscape</MenuItem>
        </TextField>
      )}
      {showImage && (
        <TextField
          select
          label="Image layout"
          size="small"
          value={value.imageFit}
          onChange={(event) =>
            onChange({ ...value, paper: 'a4', imageFit: event.target.value as PrintSettings['imageFit'] })
          }
          title="Images preserve proportions and the visible table preview."
          sx={{ minWidth: 230 }}
        >
          <MenuItem value="content">Dashboard</MenuItem>
          <MenuItem value="page">Match PDF page</MenuItem>
        </TextField>
      )}
    </Stack>
  );
}
